import React from 'react';
import { BrowserRouter as Router, Route, Routes, NavLink } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Sidebar from './components/Sidebar';
import Categories from './Pages/Categories';
import SubCategories from './Pages/SubCategories';
import Purity from './Pages/Purity';
import Counters from './Pages/Counters';
import SalesPersons from './Pages/SalesPersons';
import Products from './Pages/Products';
import Billing from './Pages/Billing';
import Report from './Pages/Report';
import Commission from './Pages/Commission';
import BillingReport from './Pages/BillingReport';


function Page({ title }) {
  return (
    <div className="p-4">
      <h2>{title}</h2>
      <p>Content for {title} will go here.</p>
    </div>
  );
}

function App() {
  return (
    <Router>
       <div className="d-flex" style={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #1c1b2f, #2c2a4a)', // deep luxury purple/navy
          color: '#f4e9d8', // light gold text
        }}>
        <Sidebar />
        <div className="flex-grow-1 p-3">
          <Routes>
            <Route path="/categories" element={<Categories />} />
            <Route path="/subcategories" element={<SubCategories />} />
            <Route path="/purity" element={<Purity />} />
            <Route path="/counters" element={<Counters />} />
            <Route path="/salespersons" element={<SalesPersons />} />
            <Route path="/products" element={<Products />} />
            <Route path="/billing" element={<Billing />} />
            <Route path="/report" element={<Report />} />
            <Route path="/commission" element={<Commission />} />
            <Route path="/billing-report" element={<BillingReport />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
